import React, {Component} from 'react'
import {AppBar, Button, Dialog, DialogActions, DialogContent, Toolbar, Typography,} from '@material-ui/core'
import FuseChipSelect from "../../../../@fuse/components/FuseChipSelect/FuseChipSelect"
import {withStyles} from '@material-ui/core/styles/index'
import {bindActionCreators} from 'redux'
import ReduxGlobal from "../../../../store/actionreducers/globalView"
import {connect} from 'react-redux'
import {constDataDialogs} from "../../../../constants"
import NewCalendarService from '../../../../service/new-calender'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import { Face, LocalHospital, InsertInvitation } from '@material-ui/icons'

const styles = theme => ({
    root: {},
    button: {
        margin: theme.spacing.unit,
    },
    formControl: {
        marginBottom: 24
    },
    table: {
        maxWidth: '100%'
    },
})

const initControlState = {
    medical: {
        id: 0,
        name: '',
        institution: '',
        phone: '',
    },
}

class AddMedicalDialog extends Component {

    constructor(props) {
        super(props)
        this.state = {
            ...initControlState,
        }
    }

    closeDataDialog = () => {
        this.props.closeDataDialog({name: constDataDialogs.name.addMedicalDialog})
        if (this.props.onClose) this.props.onClose()
    }

    _addWorkEvent = async medicalId => {
        const {
            closeLoadingMask,
            openLoadingMask,
        } = this.props

        try {
            const {
                addMedicalDialog: {
                    payload: {
                        date,
                        period,
                        workEventType,
                    },
                },
            } = this.props

            openLoadingMask()

            if (['normal', 'leader', 'firefighter'].indexOf(workEventType) !== -1)
                await NewCalendarService.addWorkEvent({
                    workEventType,
                    payload: {
                        date,
                        period,
                        medicalId,
                    },
                })

            closeLoadingMask()

        } catch (e) {
            console.warn('you got an error = ', e)
            closeLoadingMask()
        }
    }

    render() {
        const {
            classes,
            addMedicalDialog,
            medicals,
            user
        } = this.props

        const { medical } = this.state

        if (!addMedicalDialog || addMedicalDialog.props.open === false) return <div/>

        const {
            period,
            workEventType,
        } = addMedicalDialog.payload

        const workEventName = {
            normal: '一般',
            leader: '總值',
            firefighter: '救火',
        }[workEventType]

        return (
            <Dialog className={classes.root} {...addMedicalDialog.props} onClose={this.closeDataDialog} fullWidth
                    maxWidth="xs">

                <AppBar position="static">
                    <Toolbar className="flex w-full">
                        <Typography variant="subheading" color="inherit">
                            新增{workEventName}排班醫師
                        </Typography>
                    </Toolbar>
                </AppBar>

                <DialogContent classes={{root: "p-24"}}>

                   <FuseChipSelect
                       onChange={async ({value: medical}) => {
                           // const medical = medicals[index]
                           this.setState({
                               medical: {
                                   id: medical.id,
                                   name: medical.user.name,
                                   institution: medical.unvalidated_hospital_name,
                                   phone: medical.user.cell_phone_no,
                               }
                           })
                       }}
                       placeholder="請輸入醫師姓名"
                       textFieldProps={{
                           label: '排班醫師',
                           InputLabelProps: {
                               shrink: true
                           },
                           variant: 'standard'
                       }}
                       options={medicals
                           .filter(
                               (medical) => {
                                   // If the user
                                   if (user && user.medical && user.medical.fk_institution_id){
                                       return (medical.fk_job_id === 1 &&
                                               medical.level.label ===  workEventType &&
                                               medical.fk_institution_id === user.medical.fk_institution_id)
                                   } else {
                                       return (medical.fk_job_id === 1 && medical.level.label === workEventType)
                                   }
                               })
                           .map((medical) => ({value: medical, label: medical.user.name}))
                       }
                   />

                   {/* display medical information */}

                    <Table className={classes.table} aria-label="simple table">
                        <TableBody>
                            {medical.name ?
                                <TableRow>
                                    <TableCell align="right"><Face color="primary"/></TableCell>
                                    <TableCell align="right">{medical.name}</TableCell>
                                </TableRow> : <TableRow></TableRow>
                            }

                            {medical.institution ?
                                <TableRow>
                                    <TableCell align="right"><LocalHospital color="primary"/></TableCell>
                                    <TableCell align="right">{medical.institution}</TableCell>
                                </TableRow> : <TableRow></TableRow>
                            }

                            {workEventType === 'normal' ?
                                <TableRow >
                                    <TableCell align="right"><InsertInvitation color="primary" /></TableCell>
                                    <TableCell align="right">{period.label}</TableCell>
                                </TableRow> : <TableRow></TableRow>
                            }
                        </TableBody>
                    </Table>
                </DialogContent>

                <DialogActions>
                    <Button className='mb-16 mr-16' variant="raised" color="primary" disabled={medical.id === 0 } onClick={() => this._addWorkEvent(medical.id)}>儲存</Button>
                </DialogActions>

            </Dialog>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeDataDialog: ReduxGlobal.ActionCreator.closeDataDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
    }, dispatch)
}

function mapStateToProps({ global: { dataDialogs }, callHelper: { medicals }, auth}) {
    return {
        addMedicalDialog: dataDialogs[constDataDialogs.name.addMedicalDialog],
        medicals,
        user: auth.user,
    }
}


export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(AddMedicalDialog))



// WEBPACK FOOTER //
// ./src/main/content/callHelper/newCalendar/AddMedicalDialog.js